import { STATIC_RES_URL } from "@/api/apiurl";
import { useLocation } from "react-router-dom";

export const getImageUrl = (url: string) => {
  return `${STATIC_RES_URL}/${url}`;
};
// 获取路由上的query
export const geRouterQuery = (name: string) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const question = queryParams.get(name);
  return question || "";
};
